<h2 mat-dialog-title class="dialog-title">
  Hogyan szeretné magát autentikálni?
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <div class="dialog-body">
    <div class="feed-panel">
      <h3 class="feed-title">
        <mat-icon>rss_feed</mat-icon>
        Hírek
      </h3>
      @if (feedLoading()) {
        <div class="feed-loading">
          <mat-spinner diameter="24"></mat-spinner>
        </div>
      } @else if (feedItems().length === 0) {
        <p class="feed-empty">Nincsenek hírek.</p>
      } @else {
        <div class="feed-list">
          @for (item of feedItems(); track item.guid) {
            <a class="feed-item" [href]="item.link" target="_blank" rel="noopener">
              <span class="feed-item-date">{{ item.publishedAt | date:'yyyy.MM.dd.' }}</span>
              <span class="feed-item-title">{{ item.title }}</span>
              <span class="feed-item-desc">{{ item.description }}</span>
            </a>
          }
        </div>
      }
    </div>

    <div class="auth-options">
    <!-- eID Card Reader -->
    <div class="auth-option">
      <div class="auth-option-header">
        <img src="/images/kartyaolaso.png" alt="eID kártyaolvasó" class="auth-icon" />
        <h3>E-Személyi olvasóval</h3>
      </div>
      <p class="auth-description">Azonosítás e-személyi igazolvánnyal és kártyaolvasóval</p>
      <button
        mat-raised-button
        color="primary"
        (click)="authenticateWithEid()"
        [disabled]="loading().eid"
        class="auth-button"
      >
        @if (loading().eid) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Autentikálás
        }
      </button>
    </div>

    <!-- Mobile Token -->
    <div class="auth-option">
      <div class="auth-option-header">
        <img src="/images/mobiltoken.png" alt="Mobil token" class="auth-icon" />
        <h3>Mobiltokenes azonosítás</h3>
      </div>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Mobil token</mat-label>
        <input matInput [formControl]="motpControl" placeholder="Adja meg a mobil tokent" />
        @if (motpControl.hasError('required') && motpControl.touched) {
          <mat-error>Mobil token megadása kötelező</mat-error>
        }
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        (click)="authenticateWithMobile()"
        [disabled]="loading().mobile"
        class="auth-button"
      >
        @if (loading().mobile) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Autentikálás
        }
      </button>
    </div>

    <!-- OTP Token -->
    <div class="auth-option">
      <div class="auth-option-header">
        <img src="/images/otp.png" alt="OTP token" class="auth-icon" />
        <h3>OTP tokenes azonosítás</h3>
      </div>
      <form [formGroup]="otpForm" class="otp-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Felhasználónév</mat-label>
          <input matInput formControlName="userName" />
          @if (otpForm.get('userName')?.hasError('required') && otpForm.get('userName')?.touched) {
            <mat-error>Felhasználónév megadása kötelező</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Jelszó</mat-label>
          <input matInput [type]="hidePassword() ? 'password' : 'text'" formControlName="password" />
          <button mat-icon-button matSuffix type="button" (click)="hidePassword.set(!hidePassword())">
            <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (otpForm.get('password')?.hasError('required') && otpForm.get('password')?.touched) {
            <mat-error>Jelszó megadása kötelező</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>OTP</mat-label>
          <input matInput formControlName="otp" />
          @if (otpForm.get('otp')?.hasError('required') && otpForm.get('otp')?.touched) {
            <mat-error>OTP megadása kötelező</mat-error>
          }
        </mat-form-field>
      </form>
      <button
        mat-raised-button
        color="primary"
        (click)="authenticateWithOtp()"
        [disabled]="loading().otp"
        class="auth-button"
      >
        @if (loading().otp) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Autentikálás
        }
      </button>
    </div>
    </div>
  </div>
</mat-dialog-content>

@if (allowSkip) {
  <mat-dialog-actions align="center">
    <button mat-button (click)="skipAuth()">
      Folytatás belépés nélkül
    </button>
  </mat-dialog-actions>
}
